module.exports = __webpack_public_path__ + "static/media/flowers-bombing-home-SP.52d59a6d.jpg";